module.exports = __webpack_public_path__ + "static/media/purewatt-gb-3.e117816a.jpg";